import { create } from "zustand";
import { useAddToColorCollectionModalStore } from "./add-to-color-collection-modal-store";
import { useDeleteAccountModalStore } from "./delete-account-modal-store";
import { useMySavedColorsModalStore } from "./my-saved-colors-modal-store";
import { useMyStyleModalStore } from "./my-style-modal-store";
import { useProfileImageModalStore } from "./profile-image-modal-store";
import { useAddSavedColorsToCollectionModalStore } from "./add-saved-colors-to-collection-modal-store";

export const useEditColorCollectionsStore = create((set) => ({
  isModalOpen: false,
  collectionId: null,
  isAddToCollection: false,
  addToCollectionUrl: null,
  openNewButtonModal: () => {
    useAddToColorCollectionModalStore.getState().closeModal();
    useDeleteAccountModalStore.getState().closeModal();
    useMySavedColorsModalStore.getState().closeModal();
    useMyStyleModalStore.getState().closeModal();
    useProfileImageModalStore.getState().closeModal();
    useAddSavedColorsToCollectionModalStore.getState().closeModal();

    set({
      isModalOpen: true,
      collectionId: null,
      isAddToCollection: false,
      addToCollectionUrl: null,
    });
  },
  openNewCollectionFromModal: (addToCollectionUrl) => {
    useAddToColorCollectionModalStore.getState().closeModal();
    useDeleteAccountModalStore.getState().closeModal();
    useMySavedColorsModalStore.getState().closeModal();
    useMyStyleModalStore.getState().closeModal();
    useProfileImageModalStore.getState().closeModal();

    set({
      isModalOpen: true,
      collectionId: null,
      isAddToCollection: true,
      addToCollectionUrl,
    });
  },
  openExistingCollectionFromModal: (collectionId) => {
    useAddToColorCollectionModalStore.getState().closeModal();
    useDeleteAccountModalStore.getState().closeModal();
    useMySavedColorsModalStore.getState().closeModal();
    useMyStyleModalStore.getState().closeModal();
    useProfileImageModalStore.getState().closeModal();

    set({
      isModalOpen: true,
      collectionId,
      isAddToCollection: false,
      addToCollectionUrl: null,
    });
  },
  closeModal: () =>
    set({
      isModalOpen: false,
      collectionId: null,
      isAddToCollection: false,
      addToCollectionUrl: null,
    }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));
